import { normalizeMoney } from '../Orders/SkuOrders.normalizers';

const normalizeVenueItem = venueItem => ({
  itemId: venueItem.itemId,
  venueId: venueItem.venueId,
  venueName: venueItem.venueName || null,
  venueSubtitle: venueItem.venueSubtitle || null,
  name: venueItem.name,
  menus: venueItem.menus || [],
  categories: venueItem.categories || [],
  earnings: normalizeMoney(venueItem.totalPayableAmount),
  unitsSold: Number(venueItem.unitsSold) || 0,
  ordersCount: Number(venueItem.ordersCount) || 0,
});

const normalizeItem = item => ({
  name: item.name,
  earnings: normalizeMoney(item.totalPayableAmount),
  unitsSold: Number(item.unitsSold) || 0,
  ordersCount: Number(item.ordersCount) || 0,
  venueItems: (item.venueItems || []).map(normalizeVenueItem),
});

const normalizeTopItem = topItem => ({
  name: topItem.name,
  unitsSold: Number(topItem.unitsSold) || 0,
  earnings: normalizeMoney(topItem.totalPayableAmount),
});

export const normalizeItemsReport = report => ({
  items: (report?.items || []).map(normalizeItem),
  topSellers: (report?.topSellers || []).map(normalizeTopItem),
  topEarners: (report?.topEarners || []).map(normalizeTopItem),
});
